import { withInstall } from '@visual-design/utils'

import Col from './src/col.vue'

export const VCol = withInstall(Col)
export default VCol

export * from './src/col'
